import React from 'react';

function TempLabourSvg() {
	return (
		<svg
			version="1.0"
			xmlns="http://www.w3.org/2000/svg"
			width="80pt"
			height="80pt"
			viewBox="0 0 664.000000 518.000000"
			preserveAspectRatio="xMidYMid meet"
		>
			<metadata>
				Created by potrace 1.16, written by Peter Selinger 2001-2019
			</metadata>
			<g
				transform="translate(0.000000,518.000000) scale(0.100000,-0.100000)"
				fill="#000000"
				stroke="none"
			>
				<path
					d="M3020 4847 c-48 -15 -131 -102 -151 -156 -14 -42 -19 -46 -80 -66
   -148 -50 -290 -139 -397 -247 -171 -173 -261 -350 -298 -586 -14 -91 -21 -112
   -45 -137 -60 -65 -78 -168 -44 -253 20 -48 93 -118 134 -127 28 -6 28 -6 35
   -113 8 -140 28 -218 77 -312 77 -149 186 -243 382 -330 l102 -46 3 -132 3
   -132 -108 0 c-132 0 -258 -25 -378 -73 -137 -56 -228 -119 -345 -237 -118
   -119 -183 -217 -236 -358 -63 -169 -64 -183 -64 -801 l0 -559 32 -27 c26 -22
   39 -26 67 -21 19 3 44 15 55 26 21 20 21 32 27 583 5 540 6 565 27 641 47 170
   149 331 278 439 l69 59 5 -847 5 -847 33 -29 32 -29 1129 0 c739 0 1157 4
   1208 11 103 14 253 65 348 120 91 52 228 176 289 263 57 80 107 181 142 286
   26 80 28 95 29 260 0 153 -3 185 -23 254 -95 329 -337 572 -663 666 -92 27
   -305 38 -401 21 l-66 -11 -87 55 c-163 102 -345 155 -537 155 l-108 0 0 131 0
   130 58 25 c149 65 224 109 287 166 150 138 224 311 225 530 l0 76 31 7 c17 4
   49 23 71 43 104 94 112 235 18 337 -21 23 -29 44 -34 90 -10 91 -44 219 -81
   307 -47 112 -182 305 -244 352 -16 11 -58 43 -93 70 -72 55 -193 119 -287 150
   -62 21 -64 24 -83 73 -22 60 -76 118 -132 144 -47 21 -158 24 -216 6z m155
   -192 c15 -14 25 -36 25 -51 0 -51 -71 -868 -75 -873 -3 -2 -7 -2 -9 0 -4 4
   -76 834 -76 877 0 33 43 72 80 72 19 0 40 -9 55 -25z m-283 -526 c14 -173 27
   -333 27 -356 l1 -43 -325 0 -325 0 4 23 c3 12 10 46 16 76 15 79 64 193 116
   273 l45 70 78 -76 c69 -67 83 -76 116 -76 45 0 95 44 95 85 0 39 -15 63 -87
   136 l-65 67 45 31 c57 39 208 112 222 108 6 -2 21 -135 37 -318z m561 295 c64
   -27 197 -108 197 -121 0 -3 -34 -42 -76 -85 -73 -75 -76 -80 -71 -116 8 -48
   46 -82 94 -82 30 0 46 10 113 75 l77 76 26 -34 c66 -87 133 -249 151 -364 l6
   -43 -325 0 c-303 0 -325 1 -325 18 0 32 51 657 56 680 2 12 7 22 9 22 3 0 34
   -12 68 -26z m605 -896 c15 -15 15 -51 0 -66 -9 -9 -232 -12 -940 -12 l-928 0
   -11 24 c-8 17 -8 29 0 45 l12 21 927 0 c709 0 931 -3 940 -12z m-181 -370 c-2
   -57 -11 -121 -18 -143 l-14 -40 -295 -3 -294 -2 -48 47 c-41 41 -54 48 -88 48
   -34 0 -47 -7 -88 -48 l-48 -47 -293 2 -294 3 -14 40 c-8 22 -17 86 -20 143
   l-6 102 763 0 763 0 -6 -102z m-725 -343 l30 -25 254 0 c148 0 254 -4 254 -9
   0 -15 -59 -47 -221 -119 -216 -96 -249 -106 -349 -106 -100 0 -115 4 -331 100
   -177 78 -239 110 -239 125 0 5 112 9 258 9 l259 0 23 25 c13 14 25 25 28 25 2
   0 17 -11 34 -25z m-32 -440 c63 0 132 4 153 8 l37 8 0 -155 c0 -165 -6 -195
   -48 -240 -96 -103 -254 -78 -313 49 -15 33 -19 66 -19 194 l0 153 38 -8 c20
   -5 89 -9 152 -9z m-340 -409 c17 -36 51 -85 76 -110 25 -25 74 -59 110 -76
   l64 -31 0 -195 0 -194 -335 0 -335 0 0 309 0 308 59 17 c79 22 160 33 253 35
   l77 1 31 -64z m1021 35 c42 -11 107 -33 144 -50 l69 -31 -63 -38 c-151 -89
   -318 -288 -379 -449 l-27 -73 -165 2 -165 3 -3 192 -2 193 64 29 c83 37 149
   103 188 188 l31 66 116 -6 c64 -3 150 -15 192 -26z m849 -192 c131 -36 223
   -92 330 -199 74 -73 105 -113 137 -175 105 -203 118 -414 39 -625 -73 -197
   -230 -357 -426 -437 -200 -80 -415 -70 -620 29 -91 44 -115 62 -196 142 -80
   81 -98 105 -142 196 -119 246 -109 504 29 737 44 74 157 187 240 241 77 50
   202 98 291 111 88 14 230 5 318 -20z m-1620 -874 l0 -235 -335 0 -335 0 0 235
   0 235 335 0 335 0 0 -235z m472 175 c-5 -86 15 -220 48 -322 l28 -88 -184 0
   -184 0 0 235 0 235 148 0 147 0 -3 -60z m-472 -695 l0 -95 -335 0 -335 0 0 95
   0 95 335 0 335 0 0 -95z m700 50 c19 -24 61 -67 93 -94 l59 -51 -336 0 -336 0
   0 95 0 95 243 -1 242 0 35 -44z"
				/>
				<path
					d="M4398 1535 c-17 -10 -31 -29 -37 -53 -17 -58 -14 -396 3 -435 7 -18
   85 -103 173 -189 170 -169 181 -175 242 -143 32 16 51 59 44 97 -3 15 -59 80
   -144 164 l-139 139 0 188 0 189 -29 29 c-33 33 -70 37 -113 14z"
				/>
			</g>
		</svg>
	);
}

export default TempLabourSvg;
